import { NextPage } from 'next';
import React from 'react';

import { OwnerReferralPage } from '@/components/owner-referral/OwnerReferralPage';
import { useRouter } from '@/hooks/useRouter';

const InviteOwnerPage: NextPage = () => {
  const router = useRouter();
  const referralCode = router.query.code || '';

  return <OwnerReferralPage referralCode={referralCode as string} />;
};

export default InviteOwnerPage;
